/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ExtensionIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Extension',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M32 8h-2V1.215a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V8h-6V1.215a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75V8h-2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h.035v5.5a4.5 4.5 0 0 0 4.5 4.5H22.5v3A5.312 5.312 0 0 1 12 27V11.536a5.445 5.445 0 0 0-4.6-5.5 5.2 5.2 0 0 0-5.491 3.276.767.767 0 0 0 .395.995l1.289.554a.783.783 0 0 0 1.048-.4A2.251 2.251 0 0 1 9 11.25V27a8.287 8.287 0 0 0 16.5 0v-3h1.938a4.5 4.5 0 0 0 4.5-4.5V14H32a2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Z"
    />
  </svg>`;
};
